import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Crown, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useSiteConfig } from '../contexts/SiteConfigContext';

const DISMISS_KEY = 'founding_banner_dismissed';
const PROMO_END = new Date('2028-01-01T00:00:00Z');
const COUNT_THRESHOLD = 100;
const HIDDEN_ROUTES = [/^\/play\/.+/, /^\/daily\/.+/, /^\/register/];

export const FoundingBanner = () => {
  const { user } = useAuth();
  const { foundingPromoActive, foundingMemberCount } = useSiteConfig();
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');

  if (user !== false || dismissed || !foundingPromoActive || new Date() >= PROMO_END) return null;
  if (HIDDEN_ROUTES.some((r) => r.test(pathname))) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div
      className="founding-banner relative flex items-center justify-center gap-3 px-10 py-2 text-xs sm:text-sm bg-[#8B5A3C] text-[#FFF3E4]"
      data-testid="founding-banner"
      role="region"
      aria-label="Founding Member offer"
    >
      <Crown className="hidden sm:block w-4 h-4 shrink-0 text-[#F5C89A]" />
      <p className="leading-snug text-center" data-testid="founding-banner-text">
        <span className="font-semibold">Founding Member offer:</span>{' '}
        {foundingMemberCount >= COUNT_THRESHOLD ? (
          <>
            <span className="font-semibold" data-testid="founding-banner-count">
              {foundingMemberCount.toLocaleString()} Founding Members
            </span>{' '}
            have joined. Join free now and keep Premium for life.{' '}
          </>
        ) : (
          <>Be one of the first Founding Members. Join free now and keep Premium for life.{' '}</>
        )}
        <span className="opacity-80">Offer ends Jan 01, 2028.</span>
      </p>
      <Link
        to="/register"
        className="shrink-0 rounded-full bg-[#FFF3E4] text-[#5C3A24] px-3 py-1 font-semibold transition-transform duration-200 hover:scale-105 active:scale-95"
        data-testid="founding-banner-join-btn"
      >
        Join Free
      </Link>
      <button
        onClick={dismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full opacity-70 hover:opacity-100 hover:bg-white/10 transition-opacity"
        aria-label="Dismiss offer"
        data-testid="founding-banner-dismiss-btn"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
